import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { throwOnError } from 'api/helpers';
import { operations } from 'api/schema';
import { queryClient } from 'configs/queryClient';
import useB2CServiceHistoryRequestQuery from 'hooks/useB2CServiceHistoryRequestQuery';

async function updateB2CServiceHistoryRequest(
  apiClient: ApiClient,
  id: number,
  data: operations['updateB2CServiceHistoryRequest']['requestBody']['content']['application/json'],
) {
  return await apiClient.PUT('/op/v2/b2c-service-history-request/{id}', { params: { path: { id } }, body: data });
}

export default function useUpdateB2CServiceHistoryRequestMutation(id: number) {
  const apiClient = useApiClient();

  return useMutation({
    mutationFn: (data: operations['updateB2CServiceHistoryRequest']['requestBody']['content']['application/json']) =>
      throwOnError(updateB2CServiceHistoryRequest(apiClient, id, data)),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: useB2CServiceHistoryRequestQuery.getKey(id) });
    },
  });
}
